var map = {
	"./arrow-left.svg": "6873",
	"./chevron-bottom.svg": "459a",
	"./chevron-right.svg": "a753",
	"./close.svg": "9d4a",
	"./copy.svg": "5c70",
	"./delete.svg": "ce94",
	"./file.svg": "ec8b",
	"./folder.svg": "9924",
	"./illustrations/add.svg": "db01",
	"./illustrations/empty-data.svg": "61a8",
	"./illustrations/empty-history.svg": "d36a",
	"./illustrations/wiki-empty-category.svg": "034c",
	"./menu.svg": "6ff4",
	"./move.svg": "9134",
	"./plus-circle.svg": "e812",
	"./plus.svg": "9e7b",
	"./search.svg": "e408",
	"./wiki-main.svg": "bad8",
	"./wiki-settings.svg": "7860"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";